module.exports = "/images/grey_FB.png?6a9c3a805193bbbf8550d3ac927ca8fc";